<mat-card class="mainclass">
  <div class="header">
    <div class="icon">
      <span class="material-symbols-outlined"> partner_exchange </span>
    </div>
    <div class="heading">GPM Projects Connects</div>
    <div class="arrow">
    </div>
  </div>
  <div style="display: flex;" class="mt-2">
    <div class="soon_text">Coming soon</div>
    <img src="../../../../assets/images/dashboard/comingsoon_banner.svg" width="110px" height="100%">
  </div>
</mat-card>